// src/App.jsx
import React from 'react';
import { HashRouter  as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';

// Components with folder structure
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Login from './components/Login/Login';
import Signup from './components/Signup/Signup';

// Individual components for routes
import Hero from './components/Hero/Hero';
import Features from './components/Features/Features';
import About from './components/About/About';
import Contact from './components/Contact/Contact';

// Pages
import Home from './pages/Home';
import Events from './pages/Events';
import MyEvents from './pages/MyEvents';
import PartnerForm from './components/Partner/PartnerForm';
import ShowcaseTabs from './components/ShowcaseTabs';
import ScrollToTop from './components/ScrollToTop';
function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/events" element={<Events />} /> */}
            <Route path="/features" element={<Features />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/my-events" element={<MyEvents />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
             <Route path="/partner-signup" element={<PartnerForm />} />
             <Route path="/showcase" element={<ShowcaseTabs />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;